import { render, staticRenderFns } from "./customer-display-order.vue?vue&type=template&id=0fa77f7c&scoped=true"
import script from "./customer-display-order.vue?vue&type=script&lang=js"
export * from "./customer-display-order.vue?vue&type=script&lang=js"
import style0 from "./customer-display-order.vue?vue&type=style&index=0&id=0fa77f7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa77f7c",
  null
  
)

export default component.exports